/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as VerifyEmailImport } from './routes/verify-email'
import { Route as SignUpImport } from './routes/sign-up'
import { Route as SignInImport } from './routes/sign-in'
import { Route as SetupUserImport } from './routes/setup-user'
import { Route as SelectBusinessImport } from './routes/select-business'
import { Route as ForgotPasswordImport } from './routes/forgot-password'
import { Route as CreateBusinessImport } from './routes/create-business'
import { Route as IndexImport } from './routes/index'
import { Route as OrganizationOrganizationIdIndexImport } from './routes/organization/$organizationId/index'
import { Route as OrganizationOrganizationIdOnboardingImport } from './routes/organization/$organizationId/_onboarding'
import { Route as OrganizationOrganizationIdDashboardImport } from './routes/organization/$organizationId/_dashboard'
import { Route as OrganizationOrganizationIdDashboardDashboardIndexImport } from './routes/organization/$organizationId/_dashboard/dashboard/index'
import { Route as OrganizationOrganizationIdOnboardingOnboardingSupportingDocumentsImport } from './routes/organization/$organizationId/_onboarding/onboarding/supporting-documents'
import { Route as OrganizationOrganizationIdOnboardingOnboardingSettlementAccountsImport } from './routes/organization/$organizationId/_onboarding/onboarding/settlement-accounts'
import { Route as OrganizationOrganizationIdOnboardingOnboardingPurposeOfAccountImport } from './routes/organization/$organizationId/_onboarding/onboarding/purpose-of-account'
import { Route as OrganizationOrganizationIdOnboardingOnboardingCompanyStructureImport } from './routes/organization/$organizationId/_onboarding/onboarding/company-structure'
import { Route as OrganizationOrganizationIdDashboardDashboardSettingsImport } from './routes/organization/$organizationId/_dashboard/dashboard/settings'

// Create Virtual Routes

const OrganizationOrganizationIdImport = createFileRoute(
  '/organization/$organizationId',
)()

// Create/Update Routes

const VerifyEmailRoute = VerifyEmailImport.update({
  path: '/verify-email',
  getParentRoute: () => rootRoute,
} as any)

const SignUpRoute = SignUpImport.update({
  path: '/sign-up',
  getParentRoute: () => rootRoute,
} as any)

const SignInRoute = SignInImport.update({
  path: '/sign-in',
  getParentRoute: () => rootRoute,
} as any)

const SetupUserRoute = SetupUserImport.update({
  path: '/setup-user',
  getParentRoute: () => rootRoute,
} as any)

const SelectBusinessRoute = SelectBusinessImport.update({
  path: '/select-business',
  getParentRoute: () => rootRoute,
} as any)

const ForgotPasswordRoute = ForgotPasswordImport.update({
  path: '/forgot-password',
  getParentRoute: () => rootRoute,
} as any)

const CreateBusinessRoute = CreateBusinessImport.update({
  path: '/create-business',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const OrganizationOrganizationIdRoute = OrganizationOrganizationIdImport.update(
  {
    path: '/organization/$organizationId',
    getParentRoute: () => rootRoute,
  } as any,
)

const OrganizationOrganizationIdIndexRoute =
  OrganizationOrganizationIdIndexImport.update({
    path: '/',
    getParentRoute: () => OrganizationOrganizationIdRoute,
  } as any)

const OrganizationOrganizationIdOnboardingRoute =
  OrganizationOrganizationIdOnboardingImport.update({
    id: '/_onboarding',
    getParentRoute: () => OrganizationOrganizationIdRoute,
  } as any)

const OrganizationOrganizationIdDashboardRoute =
  OrganizationOrganizationIdDashboardImport.update({
    id: '/_dashboard',
    getParentRoute: () => OrganizationOrganizationIdRoute,
  } as any)

const OrganizationOrganizationIdDashboardDashboardIndexRoute =
  OrganizationOrganizationIdDashboardDashboardIndexImport.update({
    path: '/dashboard/',
    getParentRoute: () => OrganizationOrganizationIdDashboardRoute,
  } as any)

const OrganizationOrganizationIdOnboardingOnboardingSupportingDocumentsRoute =
  OrganizationOrganizationIdOnboardingOnboardingSupportingDocumentsImport.update(
    {
      path: '/onboarding/supporting-documents',
      getParentRoute: () => OrganizationOrganizationIdOnboardingRoute,
    } as any,
  )

const OrganizationOrganizationIdOnboardingOnboardingSettlementAccountsRoute =
  OrganizationOrganizationIdOnboardingOnboardingSettlementAccountsImport.update(
    {
      path: '/onboarding/settlement-accounts',
      getParentRoute: () => OrganizationOrganizationIdOnboardingRoute,
    } as any,
  )

const OrganizationOrganizationIdOnboardingOnboardingPurposeOfAccountRoute =
  OrganizationOrganizationIdOnboardingOnboardingPurposeOfAccountImport.update({
    path: '/onboarding/purpose-of-account',
    getParentRoute: () => OrganizationOrganizationIdOnboardingRoute,
  } as any)

const OrganizationOrganizationIdOnboardingOnboardingCompanyStructureRoute =
  OrganizationOrganizationIdOnboardingOnboardingCompanyStructureImport.update({
    path: '/onboarding/company-structure',
    getParentRoute: () => OrganizationOrganizationIdOnboardingRoute,
  } as any)

const OrganizationOrganizationIdDashboardDashboardSettingsRoute =
  OrganizationOrganizationIdDashboardDashboardSettingsImport.update({
    path: '/dashboard/settings',
    getParentRoute: () => OrganizationOrganizationIdDashboardRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/create-business': {
      preLoaderRoute: typeof CreateBusinessImport
      parentRoute: typeof rootRoute
    }
    '/forgot-password': {
      preLoaderRoute: typeof ForgotPasswordImport
      parentRoute: typeof rootRoute
    }
    '/select-business': {
      preLoaderRoute: typeof SelectBusinessImport
      parentRoute: typeof rootRoute
    }
    '/setup-user': {
      preLoaderRoute: typeof SetupUserImport
      parentRoute: typeof rootRoute
    }
    '/sign-in': {
      preLoaderRoute: typeof SignInImport
      parentRoute: typeof rootRoute
    }
    '/sign-up': {
      preLoaderRoute: typeof SignUpImport
      parentRoute: typeof rootRoute
    }
    '/verify-email': {
      preLoaderRoute: typeof VerifyEmailImport
      parentRoute: typeof rootRoute
    }
    '/organization/$organizationId': {
      preLoaderRoute: typeof OrganizationOrganizationIdImport
      parentRoute: typeof rootRoute
    }
    '/organization/$organizationId/_dashboard': {
      preLoaderRoute: typeof OrganizationOrganizationIdDashboardImport
      parentRoute: typeof OrganizationOrganizationIdRoute
    }
    '/organization/$organizationId/_onboarding': {
      preLoaderRoute: typeof OrganizationOrganizationIdOnboardingImport
      parentRoute: typeof OrganizationOrganizationIdImport
    }
    '/organization/$organizationId/': {
      preLoaderRoute: typeof OrganizationOrganizationIdIndexImport
      parentRoute: typeof OrganizationOrganizationIdImport
    }
    '/organization/$organizationId/_dashboard/dashboard/settings': {
      preLoaderRoute: typeof OrganizationOrganizationIdDashboardDashboardSettingsImport
      parentRoute: typeof OrganizationOrganizationIdDashboardImport
    }
    '/organization/$organizationId/_onboarding/onboarding/company-structure': {
      preLoaderRoute: typeof OrganizationOrganizationIdOnboardingOnboardingCompanyStructureImport
      parentRoute: typeof OrganizationOrganizationIdOnboardingImport
    }
    '/organization/$organizationId/_onboarding/onboarding/purpose-of-account': {
      preLoaderRoute: typeof OrganizationOrganizationIdOnboardingOnboardingPurposeOfAccountImport
      parentRoute: typeof OrganizationOrganizationIdOnboardingImport
    }
    '/organization/$organizationId/_onboarding/onboarding/settlement-accounts': {
      preLoaderRoute: typeof OrganizationOrganizationIdOnboardingOnboardingSettlementAccountsImport
      parentRoute: typeof OrganizationOrganizationIdOnboardingImport
    }
    '/organization/$organizationId/_onboarding/onboarding/supporting-documents': {
      preLoaderRoute: typeof OrganizationOrganizationIdOnboardingOnboardingSupportingDocumentsImport
      parentRoute: typeof OrganizationOrganizationIdOnboardingImport
    }
    '/organization/$organizationId/_dashboard/dashboard/': {
      preLoaderRoute: typeof OrganizationOrganizationIdDashboardDashboardIndexImport
      parentRoute: typeof OrganizationOrganizationIdDashboardImport
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren([
  IndexRoute,
  CreateBusinessRoute,
  ForgotPasswordRoute,
  SelectBusinessRoute,
  SetupUserRoute,
  SignInRoute,
  SignUpRoute,
  VerifyEmailRoute,
  OrganizationOrganizationIdRoute.addChildren([
    OrganizationOrganizationIdDashboardRoute.addChildren([
      OrganizationOrganizationIdDashboardDashboardSettingsRoute,
      OrganizationOrganizationIdDashboardDashboardIndexRoute,
    ]),
    OrganizationOrganizationIdOnboardingRoute.addChildren([
      OrganizationOrganizationIdOnboardingOnboardingCompanyStructureRoute,
      OrganizationOrganizationIdOnboardingOnboardingPurposeOfAccountRoute,
      OrganizationOrganizationIdOnboardingOnboardingSettlementAccountsRoute,
      OrganizationOrganizationIdOnboardingOnboardingSupportingDocumentsRoute,
    ]),
    OrganizationOrganizationIdIndexRoute,
  ]),
])

/* prettier-ignore-end */
